import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Flex, Button, Select } from '@chakra-ui/react';
import LoadingState from '../components/ui/LoadingState';
import ErrorState from '../components/ui/ErrorState';
import Page from '../components/ui/Page';
import SectionCard from '../components/ui/SectionCard';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { InfoIcon } from '@chakra-ui/icons';
import client from '../utils/fetchClient';
import { useProjectContext } from '../context/ProjectContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const GroupHistoryPage = () => {
  const { group } = useParams();
  const [loading, setLoading] = useState(true);
  const [runs, setRuns] = useState([]);
  const [error, setError] = useState(null);
  const { projects, selectedProject, setSelectedProject, effectiveProjectParam } = useProjectContext();

  useEffect(() => {
    setLoading(true);
    setError(null);
    // TODO: Replace with real API call
    const params = new URLSearchParams();
    if (effectiveProjectParam) params.append('project', effectiveProjectParam);
    client.get(`${API_BASE_URL}/api/test-groups/${encodeURIComponent(group)}/history`, { query: Object.fromEntries(params) })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch group history');
        return res.json();
      })
      .then(data => {
        setRuns(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setRuns([]);
        setLoading(false);
      });
  }, [group, effectiveProjectParam]);

  return (
    <Page maxW="3xl">
      <SectionCard>
      <Flex align="center" justify="space-between" wrap="wrap" gap={3} mb={6}>
        <Heading size="lg">History for Group: {group}</Heading>
        <Select
          display={{ base: 'block', md: 'none' }}
          value={selectedProject || 'ALL PROJECTS'}
          onChange={e => { setSelectedProject(e.target.value); }}
          maxW="220px"
          bg="white"
        >
          <option value="ALL PROJECTS">All Projects</option>
          {projects.map((p, idx) => (
            <option key={(p.id ?? p) + '-' + idx} value={p.id ?? p}>{p.name ?? p}</option>
          ))}
        </Select>
      </Flex>
      {loading ? (
        <LoadingState title="Loading group history" />
      ) : error ? (
        <ErrorState message={error} onRetry={() => window.location.reload()} />
      ) : runs.length === 0 ? (
        <Flex direction="column" align="center" justify="center" minH="40vh" color="gray.500">
          <InfoIcon boxSize={12} mb={4} />
          <Text fontSize="xl" fontWeight="bold" mb={2}>No test runs found for this group</Text>
          <Text fontSize="md" mb={4}>Once you run tests for this group, their history will appear here.</Text>
          <Button as={RouterLink} to="/test-case-groups" colorScheme="green" variant="solid">
            Back to Test Groups
          </Button>
        </Flex>
      ) : (
        <Box>
          {/* TODO: Render list of runs here */}
          <Text>Test run history will be displayed here.</Text>
        </Box>
      )}
      </SectionCard>
    </Page>
  );
};

export default GroupHistoryPage; 